
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface CompanyFilterProps {
  companyFilter: string;
  uniqueCompanies?: string[];
  onCompanyChange: (value: string) => void;
}

export function CompanyFilter({
  companyFilter,
  uniqueCompanies,
  onCompanyChange,
}: CompanyFilterProps) {
  return (
    <div>
      <Label className="text-foreground">Company</Label>
      <Select value={companyFilter} onValueChange={onCompanyChange}>
        <SelectTrigger className="bg-background border-border text-foreground rounded-sm">
          <SelectValue placeholder="Select company" className="text-muted-foreground" />
        </SelectTrigger>
        <SelectContent className="bg-card border-border rounded-sm">
          <SelectItem value="all" className="text-foreground hover:bg-accent">All companies</SelectItem>
          {uniqueCompanies?.map(
            (company) =>
              company && (
                <SelectItem key={company} value={company} className="text-foreground hover:bg-accent">
                  {company}
                </SelectItem>
              )
          )}
        </SelectContent>
      </Select>
    </div>
  );
}
